import api from './api'

const BASE_URL = 'https://wi4l39akng.execute-api.ap-southeast-1.amazonaws.com/dev'

export interface ModuleItem {
  moduleId: string
  moduleName: string
  remark: string
  status: string
  hardwareId?: number
  version?: number
  createTime: string
  updateTime: string
}

export interface ModuleListResponse {
  code: string
  info: string
  data: {
    total: number
    pageSize: number
    list: ModuleItem[]
    pageNum: number
  }
}

export interface SaveModuleRequest {
  moduleName: string
  remark: string
  status: 'START' | 'DISABLED'
  hardwareId?: number
}

export interface SaveModuleResponse {
  code: string
  info: string
  data: null
}

export interface EditModuleRequest {
  moduleId: string
  moduleName: string
  hardwareId?: number
  remark: string
  status: 'START' | 'DISABLED'
}

export interface EditModuleResponse {
  code: string
  info: string
  data: string
}

export interface DeleteModuleRequest {
  moduleId: string
}

export interface DeleteModuleResponse {
  code: string
  info: string
  data: string
}

export interface ModuleDetailResponse {
  code: string
  info: string
  data: ModuleItem
}

export const getModuleList = async (
  pageNum: number = 1,
  pageSize: number = 20
): Promise<ModuleListResponse> => {
  try {
    const response = await api.get(`${BASE_URL}/OTA-ModuleHandler/list`, {
      params: {
        'pageNum ': pageNum,
        'pageSize ': pageSize,
      },
    })
    return response as unknown as ModuleListResponse
  } catch (error) {
    console.error('获取模块列表失败:', error)
    throw error
  }
}

export const saveModule = async (data: SaveModuleRequest): Promise<SaveModuleResponse> => {
  try {
    const response = await api.post(`${BASE_URL}/OTA-ModuleHandler/save`, JSON.stringify(data), {
      headers: { 'Content-Type': 'text/plain' },
    })
    return response as unknown as SaveModuleResponse
  } catch (error) {
    console.error('保存模块失败:', error)
    throw error
  }
}

export const editModule = async (data: EditModuleRequest): Promise<EditModuleResponse> => {
  try {
    const response = await api.post(`${BASE_URL}/OTA-ModuleHandler/edit`, JSON.stringify(data), {
      headers: { 'Content-Type': 'text/plain' },
    })
    return response as unknown as EditModuleResponse
  } catch (error) {
    console.error('编辑模块失败:', error)
    throw error
  }
}

export const deleteModule = async (data: DeleteModuleRequest): Promise<DeleteModuleResponse> => {
  try {
    const response = await api.post(`${BASE_URL}/OTA-ModuleHandler/delete`, JSON.stringify(data), {
      headers: { 'Content-Type': 'text/plain' },
    })
    return response as unknown as DeleteModuleResponse
  } catch (error) {
    console.error('删除模块失败:', error)
    throw error
  }
}

export interface ModuleNameItem {
  moduleId: string
  moduleName: string
}

export const getModuleNameList = async (): Promise<ModuleNameItem[]> => {
  const res = await api.get(`${BASE_URL}/OTA-ModuleHandler/listModuleNames`)
  if (res.code === '200') {
    return res.data as unknown as ModuleNameItem[]
  }
  return []
}



export const getModuleDetail = async (moduleId: string): Promise<ModuleDetailResponse> => {
  try {
    const response = await api.get(`${BASE_URL}/OTA-ModuleHandler/detail`, {
      params: { moduleId },
    })
    return response as unknown as ModuleDetailResponse
  } catch (error) {
    console.error('获取模块详情失败:', error)
    throw error
  }
}
